import { Text } from "@chakra-ui/react"
import React from "react"
import { Address } from "~/interfaces/entities/Address"
import AdressCountry from "./AddressCountry"
import { getAddressLines } from "./addressFormatter"

interface Props {
  address: Address
}

const AddressUS: React.FC<Props> = ({ address }) => {
  const addressLine = getAddressLines(address)
  const { name, city, state, postcode, country } = address

  return (
    <>
      {!!name && <Text>{name}</Text>}
      {addressLine}, {city} {state} {postcode}
      <AdressCountry code={country} />
    </>
  )
}

export default AddressUS
